export default "__VITE_ASSET__BIjt4TJB__"